import { render, staticRenderFns } from "./Block_9.vue?vue&type=template&id=46bdbd72&scoped=true&"
import script from "./Block_9.vue?vue&type=script&lang=js&"
export * from "./Block_9.vue?vue&type=script&lang=js&"
import style0 from "./Block_9.vue?vue&type=style&index=0&id=46bdbd72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bdbd72",
  null
  
)

export default component.exports